/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsColorARGB
 */
export interface AssetsMelcoModelsColorARGB {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsColorARGB
     */
    argb?: string | null;
}

export function AssetsMelcoModelsColorARGBFromJSON(json: any): AssetsMelcoModelsColorARGB {
    return AssetsMelcoModelsColorARGBFromJSONTyped(json, false);
}

export function AssetsMelcoModelsColorARGBFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsColorARGB {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function AssetsMelcoModelsColorARGBToJSON(value?: AssetsMelcoModelsColorARGB | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


